import { createElement } from "../helpers/dom-helper";

export function createLoader() {
  const loaderContainer = createElement("div", {
    id: "loaderContainer",
    style: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      display: "flex",
      "justify-content": "center",
      "align-items": "center",
      "background-color": "rgba(15, 23, 42, 0.9)",
      "z-index": "50",
      "backdrop-filter": "blur(64px)",
    },
  });
  document.body.appendChild(loaderContainer);

  const loadingText = createElement(
    "span",
    {
      style: {
        "font-size": "100px",
        "font-family": "Poppins",
        "background-image":
          "linear-gradient(to right, #2563eb, #22c55e, #6366f1)",
        color: "transparent",
        "background-clip": "text",
        animation: "pulse 1.5s infinite",
      },
    },
    "Loading"
  );
  loaderContainer.appendChild(loadingText);

  let dot = "";
  const interval = setInterval(() => {
    dot = dot.length >= 3 ? "." : dot + ".";
    loadingText.textContent = `Loading${dot}`;
  }, 1000);

  const removeLoader = () => {
    clearInterval(interval);
    if (loaderContainer) {
      loaderContainer.remove();
    }
  };

  return removeLoader;
}
